module.exports = __webpack_public_path__ + "static/media/Universite-Paris-Saclay.4564f028.png";